import script from "./DokumenPersyaratanPengajuanPJO.vue?vue&type=script&setup=true&lang=js"
export * from "./DokumenPersyaratanPengajuanPJO.vue?vue&type=script&setup=true&lang=js"

import "./DokumenPersyaratanPengajuanPJO.vue?vue&type=style&index=0&id=b300e9ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b300e9ba"]])

export default __exports__